"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubDocumentNumberingListCountersManager = void 0;
var numbering_list_counters_calculator_1 = require("./numbering-list-counters-calculator");
var SubDocumentNumberingListCountersManager = (function () {
    function SubDocumentNumberingListCountersManager(subDocument) {
        this.calculators = {};
        this.currentParagraphIndex = -1;
        this.subDocument = subDocument;
    }
    SubDocumentNumberingListCountersManager.prototype.calculateCounters = function (paragraphIndex) {
        if (paragraphIndex < this.currentParagraphIndex)
            this.reset();
        this.currentParagraphIndex = paragraphIndex;
        var paragraph = this.subDocument.paragraphs[paragraphIndex];
        var abstractNumberingListIndex = paragraph.getAbstractNumberingListIndex();
        var calculator = this.getCalculator(abstractNumberingListIndex);
        return calculator.calculateNextCounters(paragraph);
    };
    SubDocumentNumberingListCountersManager.prototype.getCalculator = function (abstractNumberingListIndex) {
        if (!this.calculators[abstractNumberingListIndex])
            this.calculators[abstractNumberingListIndex] = new numbering_list_counters_calculator_1.NumberingListCountersCalculator(this.subDocument.documentModel.abstractNumberingLists[abstractNumberingListIndex]);
        return this.calculators[abstractNumberingListIndex];
    };
    SubDocumentNumberingListCountersManager.prototype.reset = function () {
        this.calculators = {};
        this.currentParagraphIndex = -1;
    };
    return SubDocumentNumberingListCountersManager;
}());
exports.SubDocumentNumberingListCountersManager = SubDocumentNumberingListCountersManager;
